import path from 'path';
import { BlobType } from '@/queue/types';
import { downloadData, getUrl } from 'aws-amplify/storage';


class S3Uitls {
    async getFile (filePath: string, bucketName: string, customPrefix?: {public: string}) {
        try {

          const urlResult = await getUrl({
            path: filePath,
            options: {
              bucket: bucketName,
            }
          });

          const fileUrl = urlResult.url;
          const link = document.createElement('a');
          const blob = await (await fetch(fileUrl)).blob()
          link.href = URL.createObjectURL(blob);
          link.download = path.basename(filePath);
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (e: any) {
          console.error('Error downloading file:', String(e));
        }
      }
    async getFileBlob (filePath: string, bucketName: string, customPrefix?: {public: string}) {
      try {
        const downloadResult = await downloadData({
          path: filePath,
          options: {
            bucket: bucketName,
          }
        }).result;
        return await downloadResult.body.blob();
      } catch (e: any) {
        console.error('Error in creating blob:', String(e));
        const blob = new Blob()
        return blob
      }
    }

    async download(filePath: string | undefined, blob: BlobType){
      try {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        if (filePath) link.download = path.basename(filePath);
        else link.download = blob.name
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e: any) {
        console.error('Error downloading file:', String(e));
      }
    }
}

export default new S3Uitls();